webpackJsonp([73214806814668],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Banner = __webpack_require__(18);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InvestorInformation = function InvestorInformation(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sonder Definition'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Sonder Definition' })
	    ),
	    _react2.default.createElement(_Banner2.default, {
	      title: 'Investor Information',
	      subTitle: 'If you want to change the future of social, join us.'
	    }),
	    _react2.default.createElement(
	      'div',
	      { id: 'main' },
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sonder is not actively raising funding.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '\xA0'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'If you are interested in seeing our pitch deck, receiving our weekly update email, or joining the beta version of the app, please contact Connor at connor.mullins@sonder.social'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = InvestorInformation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-investor-info-js-687ace560c6e1f9180a1.js